import React from "react";

// Source
import StoreSetting from "../store/Setting";
import StoreRoute from "../store/Route";
import * as HelperSrc from "../HelperSrc";
import * as ApiUser from "../api/User";
import * as ModelRoute from "../model/Route";
import * as ModelCustomRoute from "../model/custom/Route";
import * as ModelSetting from "../model/Setting";
import * as ModelUser from "../model/User";

export default class ControllerRoute {
    // Variable
    private storeSetting: ModelSetting.Istore<ModelSetting.Idata>;
    private storageSettingData = React.useRef<ModelSetting.Idata | undefined>(undefined);
    private storeMain: ModelRoute.Istore<ModelCustomRoute.Idata>;
    private storageMainData = React.useRef<ModelCustomRoute.Idata | undefined>(undefined);

    private userData = React.useRef<ModelUser.Idata | undefined>(undefined);

    private loginPath: string;
    private mainPath: string;
    private currentPath: string;

    getStorageSetting: ModelSetting.Idata | undefined;
    getStorageMain: ModelCustomRoute.Idata | undefined;

    getApiLoadingList: Record<string, boolean>;
    setApiLoadingList: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;

    getUserData: ModelUser.Idata | undefined;
    setUserData: React.Dispatch<React.SetStateAction<ModelUser.Idata | undefined>>;

    // Method
    constructor() {
        this.storeSetting = new StoreSetting();
        this.storageSettingData.current = this.storeSetting.storageGet();
        this.storeMain = new StoreRoute();
        this.storageMainData.current = this.storeMain.storageGet();

        this.loginPath = this.storageMainData.current ? this.storageMainData.current.login.path : "";
        this.mainPath = this.storageMainData.current ? this.storageMainData.current.main.path : "";
        this.currentPath = window.location.pathname.replace(`/${HelperSrc.LABEL}`, "");

        const [getStorageSetting] = React.useState<ModelSetting.Idata | undefined>(this.storageSettingData.current);
        this.getStorageSetting = getStorageSetting;
        const [getStorageMain] = React.useState<ModelCustomRoute.Idata | undefined>(this.storageMainData.current);
        this.getStorageMain = getStorageMain;

        const [getApiLoadingList, setApiLoadingList] = React.useState<Record<string, boolean>>({});
        this.getApiLoadingList = getApiLoadingList;
        this.setApiLoadingList = setApiLoadingList;

        const [getUserData, setUserData] = React.useState<ModelUser.Idata | undefined>(this.userData.current);
        this.getUserData = getUserData;
        this.setUserData = setUserData;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            this.storageSettingData.current = this.storeSetting.storageGet();
            this.storageMainData.current = this.storeMain.storageGet();
        }, [this.storageSettingData.current, this.storageMainData.current]);
    };

    checkRedirect = (): Promise<void> => {
        return new Promise((resolve) => {
            this.setApiLoadingList((prev) => ({
                ...prev,
                myProfile: true
            }));

            ApiUser.myProfile((response) => {
                this.setApiLoadingList((prev) => ({
                    ...prev,
                    myProfile: false
                }));

                if (response instanceof Error || response.message.error) {
                    if (response instanceof Error) {
                        HelperSrc.writeLog("error", response.message);
                    } else {
                        if (window.location.pathname.replace(`/${HelperSrc.LABEL}`, "") !== this.loginPath) {
                            HelperSrc.routerHistoryPush(this.loginPath);
                        }
                    }

                    resolve();

                    return;
                }

                this.userData.current = response.data.result as unknown as ModelUser.Idata;
                this.setUserData(this.userData.current);

                if (this.userData.current) {
                    if (
                        (this.currentPath === "" || this.currentPath === "/" || this.currentPath === this.loginPath) &&
                        this.currentPath !== this.mainPath
                    ) {
                        HelperSrc.routerHistoryPush(this.mainPath);
                    }
                }

                resolve();
            });
        });
    };

    checkUserAccess = (roleList: number[], matchAll = false): boolean => {
        let result = false;

        if (this.userData.current) {
            if (matchAll) {
                if (roleList.sort() === this.userData.current.role.sort()) {
                    result = true;
                }
            } else {
                for (const role of roleList) {
                    if (this.userData.current.role && this.userData.current.role.includes(role)) {
                        result = true;
                    }
                }
            }
        }

        return result;
    };
}
